import React from 'react';

import { Box, Typography } from '@mui/material';

import { SelectField, useRecordContext } from 'react-admin';

import { get } from 'react-hook-form';

import { Actions } from '../../../../constants/actions';

const choices = [{ id: true, name: 'Yes' }, { id: false, name: 'No' }];

const getPrompt = (action: Actions) => {
  if (action === 'RuleVersionRelease') return 'Require peer review for releasing test versions?';
  return 'Require peer review for publishing live versions?';
};

const RequirePeerReviewField = ({ action }: { action: Actions }) => {
  const record = useRecordContext();
  const isEnabled = get(record, `permissions.${action}.enabled`, false);

  if (!isEnabled) return null;

  return (
    <Box display="flex" alignItems="baseline" marginBottom={3} gap={3}>
      <Typography>{getPrompt(action)}</Typography>
      <SelectField
        source={`permissions.${action}.attributes.requirePeerReview`}
        choices={choices}
        emptyText="No"
      />
    </Box>
  );
};

export default RequirePeerReviewField;
